import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import tiktokIcon from "../../../assets/images/tiktok.svg"

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="w-full bg-white text-black py-10">
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
          <div className="flex justify-center md:justify-start items-center">
            <p className="text-sm font-light">{t('footer.copyright')}</p>
          </div>
          <nav className="flex justify-center items-center">
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-8">
              <Link className="text-sm font-light hover:text-primary transition-colors" to={'privacy-policy'}>{t('footer.privacy')}</Link>
            </div>
          </nav>
          <div className="flex flex-col sm:flex-row justify-center md:justify-end items-center gap-6">
            <a className="flex items-center gap-2 text-sm font-light hover:text-primary transition-colors" href="mailto:freshgrassbio@gmail.com">
              <span className="material-symbols-outlined text-base">mail</span>
              <span>freshgrassbio@gmail.com</span>
            </a>
            <div className="flex items-center gap-4">
              <a className="text-gray-500 hover:text-primary transition-colors" href="https://tiktok.com/@freshgrass.be">
                <img src={tiktokIcon} alt="tiktok" className="w-5 h-5" />
              </a>
              {/* <a className="text-gray-500 hover:text-primary transition-colors" href="/">
                <svg aria-hidden="true" className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path clipRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" fillRule="evenodd"></path>
                </svg>
              </a> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
